(() => {
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'USD' }).format(Number(cents || 0) / 100);
  const initialize = (scope = document) => scope.querySelectorAll('[data-aera-product]').forEach((root) => {
    if (root.dataset.aeraInitialized === 'true') return;
    root.dataset.aeraInitialized = 'true';
    const form = root.querySelector('[data-aera-product-form]');
    const sticky = root.querySelector('[data-aera-sticky]');
    const purchase = root.querySelector('[data-aera-purchase]');
    const price = root.querySelector('[data-aera-current-price]');
    const compare = root.querySelector('[data-aera-compare-price]');
    const stickyPrice = root.querySelector('[data-aera-sticky-price]');
    const add = root.querySelector('[data-aera-add-to-cart]');
    const stickyAdd = root.querySelector('[data-aera-sticky-add]');
    const label = root.querySelector('[data-aera-add-label]');
    const stickyLabel = root.querySelector('[data-aera-sticky-label]');
    const offerSummary = root.querySelector('[data-aera-offer-summary]');
    const singleOffer = root.querySelector('[data-aera-single-offer]');
    const mediaItems = [...root.querySelectorAll('[data-aera-media-id]')];
    const primaryMedia = mediaItems[0];
    const mediaMarkup = new Map(mediaItems.map((item) => [item.dataset.aeraMediaId, item.innerHTML]));
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let mediaTransition;
    const availableLabel = root.dataset.aeraAvailableLabel || 'Add to cart';
    const soldOutLabel = root.dataset.aeraSoldOutLabel || 'Agotado';
    const setStickyVisibility = (visible) => {
      if (!sticky) return;
      sticky.dataset.visible = visible ? 'true' : 'false';
      sticky.inert = !visible;
      sticky.setAttribute('aria-hidden', String(!visible));
    };
    const updatePrimaryMedia = (mediaId) => {
      if (!primaryMedia || !mediaId || primaryMedia.dataset.aeraActiveMediaId === mediaId) return;
      const markup = mediaMarkup.get(mediaId);
      if (!markup) return;
      clearTimeout(mediaTransition);
      const render = () => {
        primaryMedia.innerHTML = markup;
        primaryMedia.dataset.aeraActiveMediaId = mediaId;
        requestAnimationFrame(() => primaryMedia.classList.remove('is-switching'));
      };
      if (reduceMotion) {
        render();
        return;
      }
      primaryMedia.classList.add('is-switching');
      mediaTransition = setTimeout(render, 160);
    };
    const update = (input) => {
      if (!input) return;
      const available = input.dataset.available === 'true';
      const value = formatMoney(input.dataset.price);
      if (price) price.textContent = value;
      if (stickyPrice) stickyPrice.textContent = value;
      if (compare) { const compareValue = Number(input.dataset.comparePrice || 0); const priceValue = Number(input.dataset.price || 0); compare.textContent = compareValue > priceValue ? formatMoney(compareValue) : ''; compare.hidden = compareValue <= priceValue; }
      [add, stickyAdd].forEach((button) => { if (button) button.disabled = !available; });
      if (label) label.textContent = available ? availableLabel : soldOutLabel;
      if (stickyLabel) stickyLabel.textContent = available ? availableLabel : soldOutLabel;
      if (offerSummary && input.matches('[data-aera-offer]')) {
        offerSummary.textContent = [input.dataset.offerLabel, input.dataset.offerSummary].filter(Boolean).join(' - ');
      }
      updatePrimaryMedia(input.dataset.mediaId);
    };
    form?.querySelectorAll('[data-aera-variant]').forEach((input) => input.addEventListener('change', () => update(input)));
    form?.querySelectorAll('[data-aera-hydrate-color]').forEach((input) => input.addEventListener('change', () => {
      if (!singleOffer) return;
      singleOffer.value = input.value;
      ['available', 'price', 'comparePrice', 'mediaId'].forEach((key) => {
        const datasetKey = key === 'comparePrice' ? 'comparePrice' : key;
        singleOffer.dataset[datasetKey] = input.dataset[datasetKey] || '';
      });
      if (singleOffer.checked) update(singleOffer);
      else updatePrimaryMedia(input.dataset.mediaId);
    }));
    updatePrimaryMedia(form?.querySelector('[data-aera-variant]:checked')?.dataset.mediaId);
    if (!sticky) return;
    setStickyVisibility(false);
    if (!purchase || !window.IntersectionObserver) return;
    new IntersectionObserver(([entry]) => { setStickyVisibility(Boolean(entry && entry.boundingClientRect.top < 0 && !entry.isIntersecting)); }).observe(purchase);
  });
  const ready = () => { initialize(); document.addEventListener('shopify:section:load', (event) => initialize(event.target)); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
